"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _arkReact = require("@dateam/ark-react");
var _ark = require("@dateam/ark");
var _CalendarContext = _interopRequireDefault(require("./CalendarContext"));
var _defaultLocale = _interopRequireDefault(require("./defaultLocale"));
const CalendarHeader = _ref => {
  let {
    date,
    onChange,
    className
  } = _ref;
  const {
    locale = _defaultLocale.default
  } = _react.default.useContext(_CalendarContext.default);
  const dateInfo = _react.default.useMemo(() => {
    const month = date.getMonth();
    const day = date.getDay();
    const monthLabel = locale.monthLabel[month] ?? month;
    const dayLabel = locale.dayLabel[day] ?? null;
    return {
      year: date.getFullYear(),
      month: monthLabel,
      monthNum: month,
      day: dayLabel,
      dayNum: date.getDate()
    };
  }, [locale, date]);
  const changeMonth = _react.default.useCallback(month => {
    if (!(0, _ark.isValidNumber)(month)) return;
    const newDate = date.newMonth(month);
    if ((0, _ark.isFunction)(onChange)) onChange(newDate);
  }, [date, onChange]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _arkReact.concatClassName)('calendarHeader', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "calendarHeaderDate"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "calendarHeaderMonth"
  }, dateInfo.month, " ", dateInfo.year), /*#__PURE__*/_react.default.createElement("span", {
    className: "calendarHeaderDay"
  }, dateInfo.day, " ", dateInfo.dayNum)), /*#__PURE__*/_react.default.createElement("nav", {
    className: "calendarHeaderNav"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "calendarHeaderNavBtn",
    onClick: () => changeMonth(dateInfo.monthNum - 1)
  }, "\u2039"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "calendarHeaderNavBtn",
    onClick: () => changeMonth(dateInfo.monthNum + 1)
  }, "\u203A")));
};
process.env.NODE_ENV !== "production" ? CalendarHeader.propTypes = {
  date: _propTypes.default.instanceOf(Date).isRequired,
  onChange: _propTypes.default.func,
  className: _propTypes.default.string
} : void 0;
CalendarHeader.defaultProps = {
  onChange: undefined,
  className: undefined
};
var _default = exports.default = CalendarHeader;